export default __webpack_public_path__ + "static/media/package-6.e0539b2a.svg";